import { Link } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";
import { ArrowLeft, HelpCircle, ChevronDown } from "lucide-react";
import { FAQ } from "@/components/legal/faqData";

export default function Faq() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-zinc-950 text-white">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <Link to="/auth" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8 transition">
          <ArrowLeft className="w-4 h-4" /> {t.legal?.backToHome || "Retour"}
        </Link>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 grid place-items-center rounded-xl bg-gradient-to-br from-[#FF0050] to-[#8A2BE2]">
            <HelpCircle className="w-5 h-5 text-white" />
          </div>
          <h1 className="text-3xl font-black font-display">Questions fréquentes</h1>
        </div>
        <div className="space-y-8">
          {FAQ.map((group) => (
            <section key={group.title}>
              <h2 className="text-lg font-bold text-white mb-3">{group.title}</h2>
              <div className="space-y-2">
                {group.items.map(([q, a]) => (
                  <details key={q} className="group rounded-2xl border border-white/10 bg-zinc-900/60 px-4 py-3">
                    <summary className="flex items-center justify-between gap-3 cursor-pointer list-none font-semibold text-zinc-100">
                      {q}
                      <ChevronDown className="w-4 h-4 shrink-0 text-zinc-500 transition group-open:rotate-180" />
                    </summary>
                    <p className="mt-2 text-sm text-zinc-300 leading-relaxed">{a}</p>
                  </details>
                ))}
              </div>
            </section>
          ))}
        </div>
        <p className="mt-10 text-sm text-zinc-400">
          Pas trouvé ta réponse ? Écris-nous depuis la page <Link to="/support" className="underline">Support</Link>.
          Les règles complètes sont dans les <Link to="/terms" className="underline">conditions d'utilisation</Link>.
        </p>
      </div>
    </div>
  );
}
